/* Tiger Flags product shipping calculator.
 * KABAK PDP behavior adapted for Dawn/Tiger:
 * - pre-flights /cart.js before /cart/shipping_rates.json
 * - empty cart shows a clear add-to-cart CTA
 * - cart drawer legacy forms using data-vh-shipping-form keep working
 */
(function () {
  if (window.tigerProductShippingCalculator) return;
  window.tigerProductShippingCalculator = true;

  const cepRanges = [
    [1000, 19999, 'São Paulo'],
    [20000, 28999, 'Rio de Janeiro'],
    [29000, 29999, 'Espírito Santo'],
    [30000, 39999, 'Minas Gerais'],
    [40000, 48999, 'Bahia'],
    [49000, 49999, 'Sergipe'],
    [50000, 56999, 'Pernambuco'],
    [57000, 57999, 'Alagoas'],
    [58000, 58999, 'Paraíba'],
    [59000, 59999, 'Rio Grande do Norte'],
    [60000, 63999, 'Ceará'],
    [64000, 64999, 'Piauí'],
    [65000, 65999, 'Maranhão'],
    [66000, 68899, 'Pará'],
    [68900, 68999, 'Amapá'],
    [69000, 69299, 'Amazonas'],
    [69300, 69399, 'Roraima'],
    [69400, 69899, 'Amazonas'],
    [69900, 69999, 'Acre'],
    [70000, 72799, 'Distrito Federal'],
    [72800, 72999, 'Goiás'],
    [73000, 73699, 'Distrito Federal'],
    [73700, 76799, 'Goiás'],
    [76800, 76999, 'Rondônia'],
    [77000, 77999, 'Tocantins'],
    [78000, 78899, 'Mato Grosso'],
    [78900, 78999, 'Rondônia'],
    [79000, 79999, 'Mato Grosso do Sul'],
    [80000, 87999, 'Paraná'],
    [88000, 89999, 'Santa Catarina'],
    [90000, 99999, 'Rio Grande do Sul'],
  ];

  const STRINGS = {
    addToCartFirst: 'Adicione o produto ao carrinho para calcular o frete com precisão.',
    addToCartCta: 'Adicionar ao carrinho',
    cartEstimateNote: 'Estimativa baseada nos itens atuais do carrinho.',
    requestError: 'Não foi possível consultar o frete agora. Tente novamente.',
    invalidZip: 'Informe um CEP válido (8 dígitos).',
    noRates: 'Desculpe, não enviamos para seu endereço.',
    oneRate: 'Existe uma taxa de envio para o seu endereço:',
    multipleRates: 'Existem várias taxas de envio para o seu endereço:',
  };

  const cartUrl = (
    (window.routes && window.routes.cart_url) ||
    (window.theme && window.theme.routes && window.theme.routes.cart_url) ||
    '/cart'
  ).replace(/\/$/, '');
  const cartJsonUrl = `${cartUrl}.js`.replace('//.js', '/.js');
  const ratesUrl = `${cartUrl}/shipping_rates.json`.replace(/([^:])\/\//g, '$1/');

  const inFlight = new WeakMap();

  const escapeHtml = (str) => String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');

  const inferProvince = (zip) => {
    const digits = String(zip || '').replace(/\D/g, '');
    if (digits.length < 5) return '';
    const prefix = Number(digits.slice(0, 5));
    const range = cepRanges.find(([min, max]) => prefix >= min && prefix <= max);
    return range ? range[2] : '';
  };

  const formatZip = (value) => {
    const digits = String(value || '').replace(/\D/g, '').slice(0, 8);
    if (digits.length > 5) return `${digits.slice(0, 5)}-${digits.slice(5)}`;
    return digits;
  };

  const moneyFormat = () => (
    (window.theme && window.theme.moneyFormat) ||
    (window.Shopify && window.Shopify.money_format) ||
    'R$ {{amount_with_comma_separator}}'
  );

  const formatMoney = (price) => {
    const cents = Math.round(Number.parseFloat(price) * 100);
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, moneyFormat());
    }
    return `R$ ${(cents / 100).toFixed(2).replace('.', ',')}`;
  };

  function setResult(form, { state, html }) {
    const result = form.querySelector('[data-vh-result]');
    if (!result) return;
    result.hidden = false;
    result.dataset.state = state;
    result.innerHTML = html;
  }

  function syncProvince(form) {
    if (!form) return;
    const zip = form.querySelector('[name="address[zip]"]');
    const province = form.querySelector('[name="address[province]"]');
    if (!zip || !province) return;
    province.value = inferProvince(zip.value);
  }

  function focusBuyButton() {
    const candidates = [
      'product-form button[name="add"]:not([disabled])',
      'form[action*="/cart/add"] button[name="add"]:not([disabled])',
      'form[action*="/cart/add"] [type="submit"]:not([disabled])',
    ];

    let target = null;
    for (const selector of candidates) {
      target = document.querySelector(selector);
      if (target) break;
    }
    if (!target) return;

    target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    try {
      target.focus({ preventScroll: true });
    } catch (_) {
      target.focus();
    }
  }

  function renderEmptyCart(form) {
    setResult(form, {
      state: 'info',
      html: `<p>${escapeHtml(STRINGS.addToCartFirst)}</p>
        <button type="button" class="product-shipping-calculator__cta" data-add-to-cart-cta>${escapeHtml(STRINGS.addToCartCta)}</button>`,
    });
  }

  function renderRates(form, rates) {
    if (!rates.length) {
      setResult(form, { state: 'error', html: `<p>${escapeHtml(STRINGS.noRates)}</p>` });
      return;
    }

    const heading = rates.length === 1 ? STRINGS.oneRate : STRINGS.multipleRates;
    const items = rates.map(({ presentment_name, price }) => (
      `<li class="vh-rate"><strong>${escapeHtml(presentment_name)}</strong><span>${escapeHtml(formatMoney(price))}</span></li>`
    )).join('');

    setResult(form, {
      state: 'success',
      html: `<p>${escapeHtml(heading)}</p>
        <ul class="vh-rate-list" role="list">${items}</ul>
        <p class="product-shipping-calculator__note">${escapeHtml(STRINGS.cartEstimateNote)}</p>`,
    });
  }

  function renderApiError(form, errors) {
    const lines = [];
    if (errors && typeof errors === 'object') {
      Object.keys(errors).forEach((key) => {
        const value = errors[key];
        if (Array.isArray(value)) value.forEach((message) => lines.push(String(message)));
        else if (value) lines.push(String(value));
      });
    }

    const list = lines.length
      ? `<ul class="vh-rate-list" role="list">${lines.map((message) => `<li>${escapeHtml(message)}</li>`).join('')}</ul>`
      : '';

    setResult(form, {
      state: 'error',
      html: `<p>${escapeHtml(STRINGS.requestError)}</p>${list}`,
    });
  }

  async function handleSubmit(form) {
    const submitButton = form.querySelector('[type="submit"]');
    const zipInput = form.querySelector('[name="address[zip]"]');
    const country = form.querySelector('[name="address[country]"]')?.value || 'Brazil';
    const provinceInput = form.querySelector('[name="address[province]"]');
    const digits = (zipInput?.value || '').replace(/\D/g, '');

    if (digits.length < 8) {
      setResult(form, { state: 'error', html: `<p>${escapeHtml(STRINGS.invalidZip)}</p>` });
      return;
    }

    if (provinceInput) provinceInput.value = inferProvince(digits);

    const previous = inFlight.get(form);
    if (previous) previous.abort();

    const controller = new AbortController();
    inFlight.set(form, controller);
    if (submitButton) submitButton.setAttribute('aria-busy', 'true');

    try {
      const cartResponse = await fetch(cartJsonUrl, {
        method: 'GET',
        headers: { Accept: 'application/json' },
        signal: controller.signal,
        credentials: 'same-origin',
      });
      const cart = await cartResponse.json();

      if (!cart || typeof cart.item_count !== 'number') {
        renderApiError(form, null);
        return;
      }

      if (cart.item_count === 0) {
        renderEmptyCart(form);
        return;
      }

      const ratesResponse = await fetch(ratesUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          shipping_address: {
            zip: digits,
            country,
            province: provinceInput?.value || '',
          },
        }),
        signal: controller.signal,
        credentials: 'same-origin',
      });
      const data = await ratesResponse.json();

      if (data && Array.isArray(data.shipping_rates)) {
        renderRates(form, data.shipping_rates);
      } else {
        renderApiError(form, data);
      }
    } catch (error) {
      if (error && error.name === 'AbortError') return;
      console.error('[product-shipping-calculator]', error);
      renderApiError(form, null);
    } finally {
      if (inFlight.get(form) === controller) inFlight.delete(form);
      if (submitButton) submitButton.removeAttribute('aria-busy');
    }
  }

  document.addEventListener('input', (event) => {
    const input = event.target.closest('[data-vh-shipping-form] [name="address[zip]"]');
    if (!input) return;
    const formatted = formatZip(input.value);
    if (input.value !== formatted) input.value = formatted;
    syncProvince(input.closest('form'));
  });

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-vh-shipping-form]');
    if (!form) return;
    event.preventDefault();
    syncProvince(form);
    handleSubmit(form);
  }, true);

  document.addEventListener('click', (event) => {
    const cta = event.target.closest('[data-add-to-cart-cta]');
    if (!cta) return;
    event.preventDefault();
    focusBuyButton();
  });
})();
